import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { iconClass } from 'src/app/enums/icon-class.enum';
import { AuthService } from 'src/app/tinea-components/okta/auth/auth.service';
import { UserSessionService } from 'src/app/tinea-components/okta/services/session/user-session.service';
import { environment } from 'src/environments/environment';

@Component({
selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MobileMenuComponent implements OnInit {

  iconClass = iconClass;
  logoInline = environment.core.logoInline;
  userName = '';

  constructor(public authService: AuthService, private userSessionService: UserSessionService) {}

  ngOnInit(): void {
    const user = this.userSessionService.getUser();
    this.userName = user.firstName + ' ' + user.lastName;
  }

  logout() {
    this.authService.logout();
  }
}
